export enum NotificationStatus {
    new = 'new',
    read = 'read',
    all = 'all',
}
